// extracted by mini-css-extract-plugin
module.exports = {"slate-font-size-plugin-input":"FontSizeInput_slate-font-size-plugin-input__NwfPh"};